import {Link} from 'react-router-dom';

export default function Head(){
    return(
        <>
            <div className="top-head">
                <div className="content">
                    <nav>
                        <p><i className="fa fa-fax"></i> +998(91) 123-45-67</p>
                        <p><i className="fa fa-envelope"></i> info@tsdi.uz</p>
                    </nav>
                    <nav>
                        <ul className="messenger-lists">
                            <li><Link to='/'><i className="fa fa-paper-plane cltg"></i></Link></li>
                            <li><Link to='/'><i className="fa fa-twitter cltwitter"></i></Link></li>
                            <li><Link to='/'><i className="fa fa-facebook clfacebook"></i></Link></li>
                            <li><Link to='/'><i className="fa fa-instagram clinsta"></i></Link></li>
                            <li><Link to='/'><i className="fa fa-youtube clyoutube"></i></Link></li>
                        </ul>
                        <p><i className="fa fa-fork"></i>Uzbek</p>
                        <p>Tizimga kirish <i className="fa fa-sign-out"></i></p>
                    </nav>
                    </div>
                </div>
                <div className="list-head">
                    <div className="content">
                    <ul className="lists">
                        <li className="list"><Link to="/mamuriyat"><p>Ma'muriyat</p></Link></li>
                        <li className="list"><Link to='/xodim'><p>Xodimlar</p></Link></li>
                        <li className="list">
                            <p className='list-p'>Dars jadvali
                                <ul className="inner-ul">
                                <li><Link><p>1-kurs dars jadvali</p></Link></li>
                                <li><Link><p>2-kurs dars jadvali</p></Link></li>
                                <li><Link><p>3-kurs dars jadvali</p></Link></li>
                                <li><Link><p>4-kurs dars jadvali</p></Link></li>
                                <li><Link><p>5-kurs dars jadvali</p></Link></li>
                                <li><Link><p className="not-border">6-kurs dars jadvali</p></Link></li>
                                </ul>
                            </p>
                        </li>
                        <li className="list"><Link><p>Malaka tavsifnomasi</p></Link></li>
                        <li className="list"><Link><p>Malaka talablar</p></Link></li>
                        <li className="list"><Link><p>Standartlar</p></Link></li>
                        <li className="list"><Link to="/yangilik"><p>Yangiliklar</p></Link></li>
                    </ul>
                </div>
            </div>
        </>
    )
}